<template>
  <div class="contentBox" v-if="exhibitionShow">
    <div class="scroll-wrapper" @scroll="scrolling">
      <div class="buy" v-if="instanceList.length <= 0 && !wealShow">
        <div class="buyCard" @click="handleBuy">
          <img
            class="addCloudIcon"
            src="@/assets/imgs/addCloudPhone.png"
            alt=""
          />
          <div class="addCloudText">购买云手机</div>
        </div>
      </div>
      <div
        :class="[
          'cardBox',
          gonggeshow == 9 ? 'SudokuBox' : '',
          gonggeshow == 16 ? 'SixteenHousesBox' : '',
        ]"
        v-else
      >
        <div v-for="(item, index) in instanceList" :key="index">
          <div
            :class="[
              'div_img',
              gonggeshow == 9 ? 'Sudoku' : '',
              gonggeshow == 16 ? 'SixteenHouses' : '',
            ]"
          >
            <!-- 时间 -->
            <div class="ysj_name">
              <img
                class="timeIcon"
                src="@/assets/icons/timeRemaining.png"
                alt=""
              />
              <van-count-down
                class="instanceItem"
                :time="item.expireSeconds * 1000"
                :format="
                  item.expireSeconds * 1000 > 86400000
                    ? '剩余:DD天HH小时mm分钟'
                    : '剩余:HH小时mm分钟ss秒'
                "
              />
            </div>
            <!-- 工具 -->
            <div class="set_come" @click="handlehandle(item)">
              <img
                class="settingm_g"
                src="@/assets/icons/settingUp.png"
                alt=""
              />
            </div>
            <!-- 授权 -->
            <div
              class="authorizationBox"
              v-if="item.isAuthorized == 2 || item.isAuthorized == 1"
            >
              <div class="yishouquan" v-if="item.isAuthorized == 2">
                <img src="@/assets/icons/alreadyAccredit.png" alt="" />
                <div>已授权</div>
              </div>
              <div class="beishouquan" v-if="item.isAuthorized == 1">
                <img src="@/assets/icons/byAlready.png" alt="" />
                <div>被授权</div>
              </div>
            </div>
            <!-- 维护 -->
            <div class="weihu" v-if="item.maintenanceStatus == 1">
              <div>
                <img
                  class="weihuImg"
                  src="../../assets/imgs/maintainImg.png"
                  alt=""
                />
                <p class="weihuTitle">正在维护中...</p>
              </div>
              <div class="weihuTime">
                <p>预计维护时间</p>
                <p class="time">{{ item.maintenanceText }}</p>
                <p>维护时间结束后请点击刷新按钮</p>
                <p>给您带来不便敬请谅解</p>
              </div>
            </div>
            <!-- 故障 -->
            <div
              class="weihu"
              v-else-if="item.overSoldDevice"
              @click="replace(item)"
            >
              <div>
                <img
                  class="weihuImg"
                  src="../../assets/imgs/malfunction.png"
                  alt=""
                />
                <p style="color: red" class="weihuTitle">云手机故障...</p>
              </div>
              <div class="weihuButton">立即更换</div>
            </div>
            <div
              v-else
              @click="BgsSdk_child(item, index)"
              class="feiweihu"
              :data_ref="item.instanceCode"
            >
              <img
                class="imgs"
                v-if="
                  shotinfoList && shotinfoList.length != 0 && imageurl(item)
                "
                alt=""
                :src="imageurl(item)"
              />
            </div>
          </div>
          <div class="instanceNameBox">
            <!-- <img
              class="iconUrl"
              :src="
                item.iconUrl
                  ? item.iconUrl
                  : getDeviceIcon(item.vipCode, item.deviceVersionCode)
              "
              alt=""
            /> -->
            <div class="add-wrap instanceName">
              <span class="deviceType">{{
                getDeviceType(
                  item.vipCode,
                  item.deviceVersionCode,
                  item.vipName
                )
              }}</span>
              {{ item.instanceName }}
            </div>
          </div>
        </div>
        <div v-if="wealShow">
          <div
            :class="[
              'div_img',
              'newcomerExperience',
              gonggeshow == 9 ? 'Sudoku' : '',
              gonggeshow == 16 ? 'SixteenHouses' : '',
            ]"
            @click="newWeal"
          ></div>
          <div class="add-wrap">新人体验</div>
        </div>
        <div>
          <div
            :class="[
              'div_img',
              'lijigoumai',
              gonggeshow == 9 ? 'Sudoku' : '',
              gonggeshow == 16 ? 'SixteenHouses' : '',
            ]"
            @click="lijigoumai"
            v-if="getShow"
          >
            <img
              class="addImg1"
              src="../../assets/imgs/addCloudPhone.png"
              alt=""
            />
            <div class="addText">新增云手机</div>
            <!-- <img class="addImg2" src="../../assets/imgs/addText.png" alt="" /> -->
          </div>
          <div class="add-wrap">新增云手机</div>
        </div>
      </div>
    </div>
    <van-action-sheet class="toolsetPopup pcPopup" v-model="toolsetShow">
      <div class="content">
        <div class="titleBox">
          <div class="titleName">云手机操作</div>
          <div class="close" @click="toolsetShow = false">
            <img src="@/assets/icons/popupClose.png" alt="" />
          </div>
        </div>
        <div class="shebei_title" v-if="result.length > 0">
          <div class="shebei_content">
            <p class="p1">
              <span class="deviceType">{{
                getDeviceType(
                  result[0].vipCode,
                  result[0].deviceVersionCode,
                  result[0].vipName
                )
              }}</span>
              {{ result[0].instanceName }}
            </p>
            <div class="p2">
              <img class="idIcon" src="@/assets/imgs/ID.png" alt="" />
              <p class="id">{{ result[0].instanceId }}</p>
            </div>
          </div>
          <div class="instanceItem">
            <van-count-down
              class="instanceItem"
              :time="result[0].expireSeconds * 1000"
              :format="
                result[0].expireSeconds * 1000 > 86400000
                  ? '剩余时间:DD天HH小时mm分钟'
                  : '剩余时间:HH小时mm分钟ss秒'
              "
            />
          </div>
        </div>
        <div class="ul">
          <div class="li">
            <img
              @click="onOperate('重启')"
              src="@/assets/icons/restartIcon.png"
              alt=""
            />
            <p>重启</p>
          </div>
          <div
            class="li"
            v-if="result[0].isAuthorized != 1 && result[0].vipName != 'SVIP'"
          >
            <img
              @click="onOperate('续费')"
              src="@/assets/icons/renew.png"
              alt=""
            />
            <p>续费</p>
          </div>
          <div class="li" @click="onOperate('恢复出厂')">
            <img src="@/assets/icons/factoryResetIcon.png" alt="" />
            <p>恢复出厂</p>
          </div>
          <div class="li" @click="onOperate('更换机型')">
            <img src="@/assets/icons/newAircraft.png" alt="" />
            <p>更换机型</p>
          </div>
          <div
            class="li"
            @click="onOperate('重命名')"
            v-if="result[0].isAuthorized != 1"
          >
            <img src="@/assets/icons/nameIcon.png" alt="" />
            <p>重命名</p>
          </div>
          <div
            class="li"
            @click="onOperate('更换设备')"
            v-if="result[0].isAuthorized != 1"
          >
            <img src="@/assets/icons/replaceEquipment.png" alt="" />
            <p>更换设备</p>
          </div>
          <div class="li" @click="onOperate('复制ID')">
            <img src="@/assets/icons/duplication.png" alt="" />
            <p>复制ID</p>
          </div>
        </div>
        <!-- <van-button @click="toolsetShow = false" class="popupBtn" type="default"
          >取消</van-button
        > -->
      </div>
    </van-action-sheet>
    <ToolPopupCollection :result="result" ref="childRef"></ToolPopupCollection>
  </div>
</template>
    
    <script>
import {
  hsOrBdScreenshot,
  hsOrBdScreenshot_info,
  regWelfare,
  activityReceive,
} from "@/api/index.js";
import ToolPopupCollection from "@/components/homePage/ToolPopupCollection.vue";
import { mapMutations } from "vuex";
import { Toast } from "vant";
import buyCode from "@/utils/buyCode";
export default {
  name: "AochenContent",
  components: {
    ToolPopupCollection,
  },
  props: {
    instanceList: {
      default: null,
      type: Array,
    },
    gonggeshow: {
      default: 9,
      type: Number,
    },
    getShow: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      screenshotList: [],
      shotinfoList: this.$store.getters.screenshotList,
      userdata: null,
      setItem: null,
      instanceCodes: [],
      DemandId: [],
      recursionStatus: true,
      refreshSpeed: JSON.parse(localStorage.getItem("refreshSpeed")) || 2000,

      toolsetShow: false,
      result: [{ isAuthorized: null }],
      wealShow: false,
      exhibitionShow: false,
    };
  },

  mounted() {
    let that = this;
    that.userdata = JSON.parse(localStorage.getItem("data"));
    this.InstanceListFor();
    if (this.instanceList.length > 0) {
      this.exhibitionShow = true;
      this.scrolling();
      regWelfare();
    } else {
      this.getRegWelfare();
    }
    // 监听滚动事件
    document.addEventListener("visibilitychange", this.visibility);
    this.$bus.$on("instanceOperate", (data) => {
      this.toolsetShow = false;
    });
  },
  beforeDestroy() {
    this.$bus.$off("instanceOperate");
    this.recursionStatus = false;
    clearTimeout(this.setTime2);
    this.setTime2 = null;
    clearTimeout(this.setTime1);
    this.setTime1 = null;
    document.removeEventListener("visibilitychange", this.visibility);
    this.SET_SCREENSHOTLIST(this.shotinfoList);
  },
  watch: {
    // 监听切换卡片重新获取当前屏幕下列表的设备截图
    gonggeshow(newV, oldV) {
      if (newV) {
        clearTimeout(this.setTime1);
        clearTimeout(this.setTime2);
        this.scrolling();
      }
    },
    instanceList(newV, oldV) {
      if (newV) {
        this.InstanceListFor();
        clearTimeout(this.setTime1);
        clearTimeout(this.setTime2);
        this.scrolling();
      }
    },
  },
  computed: {
    imageurl: {
      get() {
        return function (em) {
          if (em) {
            for (let i = 0; i < this.shotinfoList.length; i++) {
              if (em.instanceCode == this.shotinfoList[i].instanceCode) {
                if (em.channelCode == "intelligent") {
                  return this.shotinfoList[i].url + "&a=" + Math.random();
                } else if (em.channelCode == "huawei") {
                  return this.shotinfoList[i].url + "?a=" + Math.random();
                } else {
                  return this.shotinfoList[i].url;
                }
              }
            }
          }
        };
      },
    },
    getDeviceType: {
      get() {
        return function (vipCode, deviceVersionCode, vipName) {
          let item = buyCode.deviceTypeOptions.find(
            (item) => item.vipCode == vipCode || item.vipName == vipName
          );
          if (item) {
            return `${item.vipType}${deviceVersionCode.substring(1)}`;
          } else {
            if (deviceVersionCode) {
              const customVipType =
              vipName.length >= 2 ? vipName.substring(0, 2) : "定制";
              return `${customVipType}${deviceVersionCode.substring(1)}`;
            } else {
              return "";
            }
          }
        };
      },
    },
  },
  methods: {
    ...mapMutations("common", ["SET_SCREENSHOTLIST"]),
    ...mapMutations("perpetual", ["SET_RENEWLIST"]),
    visibility() {
      if (document.hidden) {
        console.log("H5已切换到后台或手机息屏");
        clearTimeout(this.setTime2);
        clearTimeout(this.setTime1);
      } else {
        console.log("H5已切换到网页");
        clearTimeout(this.setTime2);
        clearTimeout(this.setTime1);
        this.scrolling();
      }
    },
    scrolling(e) {
      // 当前屏幕上下多加渲染的变量
      let num = 0;
      if (this.gonggeshow == 4) {
        num = 2;
      } else if (this.gonggeshow == 9) {
        num = 3;
      } else if (this.gonggeshow == 16) {
        num = 4;
      }
      //延时器
      clearTimeout(this.setItem);
      this.setItem = setTimeout(() => {
        // 获取所有列表节点
        var elements = document.getElementsByClassName("feiweihu");
        let arr = [];
        for (var i = 0; i < elements.length; i++) {
          var rect = elements[i].getBoundingClientRect();
          // 判断元素是否在当前屏幕范围内
          if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
            // 对符合条件的元素进行操作
            arr.push(elements[i].getAttribute("data_ref"));
          }
        }
        let index1 =
          this.instanceCodes.indexOf(arr[0]) - num >= 0
            ? this.instanceCodes.indexOf(arr[0]) - num
            : 0;
        let index2 =
          this.instanceCodes.indexOf(arr[arr.length - 1]) + num <=
          this.instanceCodes.length
            ? this.instanceCodes.indexOf(arr[arr.length - 1]) + num
            : this.instanceCodes.length - 1;
        this.DemandId = this.instanceCodes.slice(index1, index2 + 1);
        // 调用截取当前屏幕id的设备截图
        let codes = this.instanceCodes.slice(index1, index2 + 1);
        let huoshanCodes = [];
        let elseCodes = [];
        let totalCodes = this.instanceList.filter((element) =>
          codes.includes(element.instanceCode)
        );
        totalCodes.forEach((item) => {
          if (item.channelCode == "huoshan") {
            huoshanCodes.push(item.instanceCode);
          } else {
            elseCodes.push(item.instanceCode);
          }
        });
        // this.getscreenshot(this.instanceCodes.slice(index1, index2 + 1));
        if (elseCodes.length > 0) {
          this.$nextTick(() => {
            this.getscreenshot(elseCodes);
          });
        }
        if (huoshanCodes.length > 0) {
          this.getscreenshot1(huoshanCodes);
        }
        // arr.push()
      }, 200);
    },
    // 启动云手机
    BgsSdk_child(em, dex) {
      clearTimeout(this.setTime2);
      clearTimeout(this.setTime1);
      this.$emit("openCloudPhone", em);
    },
    // 超卖更换设备
    replace(em) {
      this.$refs.childRef.movement("更换机型");
    },
    // 立即购买
    lijigoumai() {
      this.$router.push({
        path: "/newCloudPhone",
        // query: { type: 0 },
      });
    },

    InstanceListFor() {
      let a = this.instanceList;
      this.instanceCodes = [];
      for (let i = 0; i < a.length; i++) {
        if (a[i].maintenanceStatus != 1) {
          this.instanceCodes.push(a[i].instanceCode);
        }
      }
    },
    // 获取设备截图
    async getscreenshot(instanceCodes) {
      if (instanceCodes.length > 0) {
        let that = this;
        // 超卖不去请求设备截图
        let codeS = [];

        this.instanceList.forEach((lits) => {
          if (!lits.overSoldDevice) {
            instanceCodes.forEach(function (item) {
              if (lits.instanceCode == item) {
                codeS.push(item);
              }
            });
          }
        });
        let data = {
          instanceCodes: codeS,
          quality: 3,
          fullQuality: 50,
          pictureQuality: 50,
          isBdSync: true,
          scale: 576,
        };
        await hsOrBdScreenshot(data).then((res) => {
          if (res.code == 200) {
            that.screenshotList = res.data;
            setTimeout(function () {
              that.getscreenshotinfo();
            }, 1000);
            clearTimeout(this.setTime2);
            this.setTime2 = setTimeout(() => {
              if (this.recursionStatus) {
                this.getscreenshot(instanceCodes);
              }
              // this.scrolling()
            }, this.refreshSpeed);
          }
        });
      }
    },
    // 获取设备截图
    async getscreenshot1(instanceCodes) {
      if (instanceCodes.length > 0) {
        let that = this;
        // 超卖不去请求设备截图
        let codeS = [];
        this.instanceList.forEach((lits) => {
          if (!lits.overSoldDevice) {
            instanceCodes.forEach(function (item) {
              if (lits.instanceCode == item) {
                codeS.push(item);
              }
            });
          }
        });
        let data = {
          instanceCodes: codeS,
          quality: 50,
          fullQuality: 50,
          pictureQuality: 50,
          isBdSync: true,
          scale: 576,
        };
        await hsOrBdScreenshot(data).then((res) => {
          if (res.code == 200) {
            that.screenshotList = res.data;
            setTimeout(function () {
              that.getscreenshotinfo();
            }, 1000);
            clearTimeout(this.setTime1);
            this.setTime1 = setTimeout(() => {
              if (this.recursionStatus) {
                this.getscreenshot1(instanceCodes);
              }
              // this.scrolling()
            }, 2000);
          }
        });
      }
    },
    // 获取截图结果
    async getscreenshotinfo() {
      let that = this;
      let taskIds = [];
      that.screenshotList.forEach((item) => {
        if (item.taskId) {
          taskIds.push({
            instanceCode: item.instanceCode,
            taskId: item.taskId,
          });
        } else {
          //智能云直接返回的url，不需要获取截图结果
          that.shotinfoList = that.mergeArrayById(
            that.shotinfoList,
            that.screenshotList
          );
        }
      });
      if (taskIds && taskIds.length > 0) {
        await hsOrBdScreenshot_info(taskIds).then((res) => {
          if (res.code == 200) {
            that.shotinfoList = that.mergeArrayById(
              that.shotinfoList,
              res.data
            );
          }
        });
      }
    },
    // 截图缓存函数
    mergeArrayById(arr1, arr2) {
      arr2.forEach((item2) => {
        const index = arr1.findIndex(
          (item1) => item1.instanceCode === item2.instanceCode
        );
        if (index !== -1) {
          // 如果在arr1中找到了相同的id，则替换该元素
          if (item2.url) {
            this.$set(arr1, index, item2);
          }
        } else {
          // 如果在arr1中没有找到相同的id，则添加该元素
          arr1.push(item2);
        }
      });
      return arr1;
    },
    handlehandle(item) {
      this.toolsetShow = true;
      this.result = [item];
    },
    /** */
    onOperate(code) {
      switch (code) {
        // case "更换设备":
        //   this.$router.push("/grouping");
        //   break;
        case "复制ID":
          let value = this.result.map((item) => item.instanceId).join("\n");
          this.$common.moreCopy(value, "复制成功!");
          this.toolsetShow = false;
          break;
        case "续费":
          this.$router.push({
            path: "/renewCloudPhone",
            // query: { type: 1 },
          });
          this.SET_RENEWLIST(this.result);
          break;
        default:
          this.$refs.childRef.movement(code);
          break;
      }
    },
    handleBuy() {
      this.$auth.checkLogin(
        () => {
          this.$router.push({
            path: "/newCloudPhone",
            // query: { type: 0 },
          });
        },
        this.$router,
        this.$store.getters.token
      );
    },
    // 获取是否领取过注册福利
    getRegWelfare() {
      regWelfare().then((res) => {
        this.exhibitionShow = true;
        if (res.code == 200) {
          if (res.data.type == "0") {
            this.wealShow = true;
          }
        }
      });
    },
    newWeal() {
      activityReceive({}).then((res) => {
        if (res.code == 200) {
          Toast("领取成功");
          this.wealShow = false;
          this.$bus.$emit("instanceOperate", "");
        }
      });
    },
  },
};
</script>
    
<style lang="less" scoped>
.contentBox {
  height: calc(100% - 94px);
  cursor: pointer;

  .buy {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 17px 35px 56px 35px;
    .buyCard {
      width: 100%;
      height: 100%;
      overflow: hidden;
      background: #ecefff;
      border-radius: 15px;
      border: 2px solid #ffffff;
      opacity: 0.9;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .addCloudIcon {
        width: 83px;
        height: 83px;
      }
      .addCloudText {
        font-weight: 500;
        font-size: 19px;
        color: #596380;
        margin-top: 17px;
      }
    }
  }
}
.shake-text {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  font-size: 20px;
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }
  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
.contentBox {
  .SudokuBox {
    display: grid !important;
    grid-template-columns: 32% 32% 32% !important;
  }
  .SixteenHousesBox {
    display: grid !important;
    grid-template-columns: 24% 24% 24% 24% !important;
  }
  .cardBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    padding: 0 14px;
    box-sizing: border-box;
    margin-bottom: 10px;
    .Sudoku {
      width: calc(100%);
      height: 196px;
      border-radius: 5px;
      overflow: hidden;

      .addImg1 {
        width: 28px !important;
        margin-bottom: 6px !important;
      }
      .addImg2 {
        width: 50px !important;
      }
      .weihu {
        font-size: 5px;
        .weihuImg {
          width: 40px;
        }
        .weihuTitle {
          font-size: 8px;
          margin-bottom: 6px;
        }
        .weihuTime {
          p {
            margin: 2px 0;
            color: rgb(74, 74, 74);
            font-family: 思源黑体;
            font-size: 5px;
            font-weight: 400;
            letter-spacing: 0px;
            text-align: center;
          }
          .time {
            color: #886df3;
          }
        }

        .weihuButton {
          background: #886df3;
          border-radius: 4px;
          padding: 0px 12px;
          height: 20px;
          margin-top: 6px;
          font-size: 8px !important;
          color: #fff;
          line-height: 20px;
        }
      }
    }
    .SixteenHouses {
      width: calc(100%);
      height: 146px;
      border-radius: 9px;
      .imgs {
        // border-radius: 3px;
      }

      .addImg1 {
        width: 21px !important;
        margin-bottom: 4.5px !important;
      }
      .addImg2 {
        width: 37.5px !important;
      }
    }
    .yeshu {
      width: 100%;
      text-align: center;
    }
  }
  .instanceNameBox {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    font-size: 12px;
    .iconUrl {
      width: 18px;
      height: 18px;
    }
    .instanceName {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .div_img {
    position: relative;
    height: 298px;
    overflow: hidden;
    border-radius: 20px;
    // margin: 0 10px 10px 0;
    margin-top: 10px;
    // border: 1px solid #999999;
    background: linear-gradient(180deg, #eeeefd 0%, #ffffff 100%);
    border: 1px solid #e6e9f2;
    .shengyu_time {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 32px;
      background: rgba(30, 33, 51, 0.6);
      border-radius: 0px 0px 12px 12px;
      color: #fff;
      text-align: center;
      line-height: 32px;
      font-size: 10px;
    }
    .imgs {
      width: 100%;
      height: 100%;
      overflow: hidden;
      // border-radius: 10px;
    }
    .ysj_name {
      position: absolute;
      left: 0;
      bottom: 0px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 0 9px 0px 0px;
      white-space: nowrap;
      padding: 5px;
      display: flex;
      align-items: center;
      .timeIcon {
        width: 8px;
        height: 8px;
        margin-right: 2px;
      }
      .instanceItem {
        font-size: 6px;
        color: #fff;
        line-height: 6px;
      }
    }
    .set_come {
      position: absolute;
      right: 0;
      bottom: 0px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 9px 0px 0px 0px;
      white-space: nowrap;
      padding: 0 4px;
      .settingm_g {
        width: 10px;
        height: 10px;
      }
    }
    .authorizationBox {
      position: absolute;
      right: 0;
      top: 0;
      border-radius: 0px 0px 0px 5px;
      white-space: nowrap;
      font-size: 6px;
      overflow: hidden;
      color: #fff;
      .yishouquan {
        background: linear-gradient(90deg, #8974ff 3%, #b1a6ff 100%);
        width: 100%;
        height: 100%;
        padding: 2px 5px;
        display: flex;
        align-items: center;
      }
      .beishouquan {
        background: linear-gradient(90deg, #30ce57 3%, #89dd62 100%);
        width: 100%;
        height: 100%;
        padding: 2px 5px;
        display: flex;
        align-items: center;
      }
      img {
        width: 8px;
        height: 8px;
        margin-right: 2px;
      }
    }
    .weihu {
      width: calc(100% - 0px);
      height: 100%;
      // background-size: 140px 140px;
      // position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 10px;
      .weihuImg {
        width: 80px;
      }
      .weihuTitle {
        font-size: 13px;
        font-weight: 500;
        color: #886df3;
        margin-bottom: 6px;
      }
      p {
        margin: 2px 0;
        color: rgb(74, 74, 74);
        font-family: 思源黑体;
        font-size: 10px;
        font-weight: 400;
        letter-spacing: 0px;
        text-align: center;
      }
      .weihuButton {
        background: linear-gradient(145deg, #00c2ff 0%, #0066ff 100%);
        padding: 0px 12px;
        height: 20px;
        margin-top: 6px;
        font-size: 8px !important;
        color: #fff;
        border-radius: 20px;
        line-height: 20px;
      }
    }

    .feiweihu {
      height: 100%;
      width: 100%;
      // background-color: #f2f8ff;
      border-radius: 5px;
    }
  }
  .custom_indicator {
    margin-top: 312px;
  }
  .newcomerExperience {
    background-image: url("@/assets/imgs/newcomerExperience.png");
    background-size: 100% 100%;
    border: 1px solid #ffffff;
    opacity: 0.9;
  }
  .lijigoumai {
    background-size: 100% 100%;
    // margin: 0 12px !important;
    background: #ecefff;
    border: 1px solid #ffffff;
    opacity: 0.9;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 164px;
    .addImg1 {
      width: 36px;
      margin-bottom: 6px;
    }
    .addText {
      font-weight: 500;
      font-size: 8px;
      color: #596380;
    }
  }
  .ljgm_btn {
    position: absolute;
    bottom: 50px;
    left: 0;
    border: none;
    background: none;
    margin: 0 47px;
    color: #fff;
    width: calc(100% - 94px);
    height: 40px;
    background: #558bff;
    border-radius: 22px;
  }
  /deep/ .van-tabs__wrap {
    display: none;
  }
  .van-swipe {
    margin: 10px 0 10px 10px;
    width: calc(100% - 10px);
  }
}

.toolsetPopup {
  background: #f4f6fa;
  .content {
    padding: 25px 0 31px 0;
    .titleBox {
      display: flex;
      justify-content: center;
      position: relative;
      .titleName {
        font-weight: 600;
        font-size: 17px;
        color: #222222;
      }
      .close {
        width: 25px;
        height: 25px;
        position: absolute;
        right: 21px;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 17px;
          height: 17px;
        }
      }
    }
    .shebei_title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 8px;
      padding: 6px 16px;
      background: #fff;
      margin: 20px;
      border-radius: 8px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 20px;
      }
      .shebei_content {
        // margin-left: 16px;
        text-align: left;
        p {
          margin: 0;
          height: 22px;
          font-size: 13px;
          font-weight: 400;
          color: #999999;
          line-height: 22px;
        }
        .p1 {
          font-weight: 500;
          font-size: 15px;
          color: #505465;
        }
        .p2 {
          display: flex;
          align-items: center;
          .idIcon {
            width: 18px;
            height: 17px;
            margin-right: 4px;
          }
          .id {
            font-weight: 500;
            font-size: 10px;
            color: #b8bdcc;
          }
        }
      }
      .instanceItem {
        font-weight: 400;
        font-size: 13px;
        color: #a9adb6;
        max-width: 120px;

      }
    }
    .ul {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 0px;
      margin-top: 19px;
      padding: 0 13px;
      .li {
        text-align: center;
        display: inline-block;
        font-size: 14px;
        margin: 6px 8px;
        background: #fff;
        border-radius: 13px;
        padding: 8px 0;
        img {
          width: 25px;
          height: 25px;
        }
        p {
          font-weight: 500;
          font-size: 10px;
          color: #505465;
          margin-top: 2px;
        }
      }
    }
    .popupBtn {
      width: 333px;
      height: 42px;
      background: #886df3;
      border-radius: 267px;
      margin-top: 19px;
      color: #fff;
      font-weight: 500;
      font-size: 15px;
    }
  }
}
</style>